var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Header', {
    attrs: {
      "showMemberCenter": false,
      "meta": _vm.meta,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _c('div', {
    staticClass: "awards-list"
  }, _vm._l(_vm.products, function (product) {
    return _c('MgmProductItem', {
      key: product,
      attrs: {
        "product": product
      }
    });
  }), 1)])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "description"
  }, [_vm._v(" 寫一些說明，多達"), _c('b', [_vm._v("60")]), _vm._v("件獎品，"), _c('br'), _vm._v(" 速速加入Coleman官方賬號，週週抽週週送～ ")]);
}]

export { render, staticRenderFns }